<template>
  <div class="footer">
    <div class="shape">
      <img class="image" src="@/assets/img/animation.png" />
    </div>
    <div class="footer-content">
      <!-- <div class="content">
        <div class="adaptation-double">
          <ul class="footer-content-item">
            <h3 class="subtitle">特色产品</h3>
            <li class="content-item">
              <a class="link">轨道产品</a>
            </li>
            <li class="content-item">
              <a class="link">电阻产品</a>
            </li>
            <li class="content-item">
              <a class="link">新能源产品</a>
            </li>
            <li class="content-item">
              <a class="link">低压开关柜</a>
            </li>
            <li class="content-item">
              <a class="link">软件产品</a>
            </li>
          </ul>
          <ul class="footer-content-item">
            <h3 class="subtitle">服务中心</h3>
            <li class="content-item">
              <a class="link">电力运维</a>
            </li>
            <li class="content-item">
              <a class="link">电力设计</a>
            </li>
            <li class="content-item">
              <a class="link">售电</a>
            </li>
            <li class="content-item">
              <a class="link">下载中心</a>
            </li>
            <li class="content-item">
              <a class="link">联系我们</a>
            </li>
          </ul>
        </div>
        <div class="adaptation-double">
          <ul class="footer-content-item">
            <h3 class="subtitle">典型业绩</h3>
            <li class="content-item">
              <a class="link">变配电EPC总承包</a>
            </li>
            <li class="content-item">
              <a class="link">电力自动化</a>
            </li>
            <li class="content-item">
              <a class="link">新能源</a>
            </li>
            <li class="content-item">
              <a class="link">海外工程</a>
            </li>
          </ul>
          <ul class="footer-content-item">
            <h3 class="subtitle">地址</h3>
            <li class="content-item last-address">
              <v-icon class="icon" name="map-marker" />
              <div>哈尔滨市松北区科技一街399号</div>
            </li>
            <li class="content-item last-address">
              <v-icon class="icon" name="envelope" />
              <div class="email">Email: support@togotech.cn</div>
            </li>
            <li class="content-item last-address">
              <v-icon class="icon phone" name="phone" />
              <div>Phone:0451-51855226</div>
            </li>
          </ul>
        </div>
      </div> -->
      <div class="copyright">
        <p class="copyright-item">Copyright ©1999-2020深圳市艾迪科物联网技术有限公司版权所有</p>
        <p class="copyright-item"><a class="record-number" href="#">备案号：粤ICP备2021142121号-1</a></p>
      </div>
    </div>
    <svg class="animation" xmlns="http://www.w3.org/2000/svg" width="22" height="22">
      <text
        data-name="+"
        transform="matrix(1.437 1.434 -1.437 1.434 -.832 23.066)"
        font-size="25"
        fill="#27eac8"
        text-anchor="middle"
        font-family="Roboto"
      >
        <tspan x="0">+</tspan>
      </text>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #f7fafd;
  font-size: 14px;
  position: relative;
  padding: 0px 15px;
  @media (max-width: 400px) {
    height: 100%;
    .shape {
      display: none;
    }
  }
}

.shape {
  position: absolute;
  // top: 20%;
  top: 0;
  left: 30px;
  opacity: 0.4;

  .image {
    animation: rotate 4s linear infinite;
    -webkit-animation: rotate 4s linear infinite;

    @-webkit-keyframes rotate {
      from {
        -webkit-transform: rotateY(360deg);
      }

      to {
        -webkit-transform: rotateY(0deg);
      }
    }

    @keyframes rotate {
      from {
        -webkit-transform: rotateY(360deg);
      }

      to {
        -webkit-transform: rotateY(0deg);
      }
    }
  }
}

.animation {
  position: absolute;
  top: 15%;
  right: 10%;
  animation: circle 20s infinite linear;

  @-webkit-keyframes circle {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-moz-keyframes circle {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-ms-keyframes circle {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @-o-keyframes circle {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes circle {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}

.footer-content {
  position: relative;
  padding-top: 70px;
  margin-right: auto;
  margin-left: auto;
  // min-width: 540px;
  background: url("../../assets/img/footer-back.png") no-repeat 100% 100%;

  @media (max-width: 400px) {
    height: 100%;
    .content {
      display: inline;
    }
  }

  @media (max-width: 576px) {
    height: 100%;
    // max-width: 540px;
    width: auto;
    .content {
      justify-content: space-around;
      .adaptation-double {
        display: inline;
        .footer-content-item {
          margin-bottom: 30px;
          width: auto;
          flex: 1;
        }
      }
    }
    padding-right: 10px;
    padding-left: 10px;
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (min-width: 768px) {
    max-width: 620px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 1200px) {
    max-width: 1040px;
  }
}

.content {
  display: flex;
  justify-content: space-between;

  .adaptation-double {
    display: flex;
    width: 50%;
  }

  .footer-content-item {
    width: 50%;
    padding: 0 15px;
    text-align: left;
    margin: 0;

    .subtitle {
      font-size: 16px;
      font-weight: 500;
      margin-top: 0px;
      margin-bottom: 20px;
      color: #0e314c;
    }

    .content-item {
      list-style: none;
      margin-bottom: 10px;
      text-align: left;
      color: #6084a4;
      line-height: 1.5;

      .link {
        transition: 0.5s;
        text-decoration: none;
      }
    }
  }
}

.icon {
  width: 14px;
  padding: 4px;
  margin-right: 4px;
}

.phone {
  transform: rotateY(180deg);
}

.last-address {
  display: flex;
  align-items: center;

  .email {
    word-break: break-all;
  }
}

.copyright {
  margin-top: 60px;
  border-top: 1px solid #d8ebfd;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  
  .copyright-item {
    margin: 0;
    color: #6084a4;
    font-size: 14px;
    line-height: 1.9;
    .record-number{
      color: #6084a4;
      text-decoration: none;
      &:link {
        color: #6084a4;
      }

      &:visited {
        color: #6084a4;
      }

      &:hover {
        color: #6084a4;
      }

      &:active {
        color: #6084a4;
      }
    }
  }
}
</style>